import React, { useEffect, useState, useMemo } from "react";
import Modal from "../../Components/Kanban/Modal/Modal";
import styled from "styled-components";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import { useDispatch, useSelector } from "react-redux";
import filterSign from "../../Images/filterSign.svg";
import { useSession } from "../../authentications/SessionContext";
import { userAction } from "../../Redux/Reducers/UsersSlice";
import { PAGINATION_DEFAULT_LIMIT } from "../../utilities/constants";
import { TableContainer } from "../../Components/StyledComponents/TableContainer/TableContainer";
import { unLink } from "../../DataApi/unlink";
import ReactSelect from "react-select";
import { useLocation } from "react-router-dom";
import NewUserForm from "../../Components/UsersComponent/NewUserForm";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import { handleResponse } from "../../utilities/handleResponse";
import Pagination from "../../Components/Table/TableFooter/Pagination";
import { USERS_LIST_TABLE_VIEW } from "../../utilities/tables-view-constants";
import { VTEX_USERS_LIST_TABLE_VIEW } from "../../utilities/tables-view-constants";
import TableBody from "../../Components/Table/TableBody";
import TableHeader from "../../Components/Table/TableHeader";
import TableToolbar from "../../Components/Table/TableToolbar";
import { MainSectionOfPage } from "../../Components/StyledComponents/FirstSectonOfPages/MainSectionOfPage";
import { primaryColor } from "../../utilities/colors";

const UsersFilterListOptions = [
  { label: "Internal Users", value: JSON.stringify(["share", "=", false]) },
  { label: "Inactive Users", value: JSON.stringify(["active", "=", false]) },

  { label: "All Users", value: "" },
];
const UsersSortListOption = [
  { label: "Default", value: "create_date" },
  { label: "Name", value: "name" },
  { label: "Login", value: "login" },
  { label: "Authentication", value: "login_date" },
  { label: "Language", value: "lang" },
  { label: "Company", value: "company_id" },
];

const NewButton = styled.button`
  border-radius: 15px;
  background-color: ${(props) =>
    props["data-isvtex"] ? "#000000" : "#ff5837"};
  color: ${(props) =>
    props["data-isvtex"] ? primaryColor.primary : "#ffffff"};
  border: none;
  width: 130px;
  min-width: 125px;
  height: 40px;
  margin-right: 10px;
`;
const ProductsContainer = styled.div`
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 2rem;
  margin: 30px;
  border-radius: 20px;
`;

const SearchDiv = styled.form`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  background-color: #f8f9fa;
  family-font: "Inter";

  input[type="text"] {
    width: 100%;
    padding: 10px;
    padding-left: 40px;
    border-radius: 5px;
    border: none;
    font-size: 16px;
    margin-right: 10px;
    background-color: #f8f9fa;
    &:focus {
      border: none;
      outline: none;
    }
  }
  .search-container {
    position: relative;
    width: 100%;
  }
`;
const SearchIcon = styled.span`
  position: absolute; /* Position the icon absolutely */
  top: 50%;
  left: 2px;
  transform: translateY(-50%);
  color: #b0b7c3;
  cursor: pointer;
  padding: 12px;
`;

const Users = () => {
  const { sessionInfo } = useSession();
  const {
    company_id,
    context,
    user_companies,
    user_id,
    isVTEX,
    is_vtex_admin,
    is_vtex_omantal,
    is_merchant,
  } = sessionInfo;
  const {
    setIsDisabled: setDisableModalButton,
    ConfirmationModal,
    setTitle,
    setMetaData,
    toggleModal,
    setOpenModal: setOpenConfirmationModal,
  } = useConfirmationModal();
  const { UsersList, length, loading } = useSelector((state) => state.users);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const [UsersSort, setUsersSort] = useState(UsersSortListOption[0].value);
  const [UsersTypeFilter, setUsersTypeFilter] = useState(
    UsersFilterListOptions[0]
  );
  const [selectedUser, setSelectedUser] = useState(null);

  const [filterDirection, setFilterDirection] = useState("desc");
  const { language, translations } = useLanguage();
  const t = translations[language];
  const [selectedRows, setSelectedRows] = useState([]);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(PAGINATION_DEFAULT_LIMIT);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const location = useLocation();

  // Access the state object passed from the previous component
  const stateData = location?.state;
  const shouldUserModalOpen = stateData ? stateData.openUserModal : false;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handleChangePage = (value) => {
    setCurrentPage(value);
  };
  const handleCreateClick = () => {
    setSelectedUser(null); // Clear selectedUser when creating a new user

    setIsCreateModalOpen(true);
  };
  const handleCloseModal = () => {
    setSelectedRecord([]);
    setIsCreateModalOpen(false);

    setSelectedRecord({});
    setSelectedUser(null);

    // setIsDetailsModalOpen(false);
  };

  const handleDeleteSelection = () => {
    setDisableModalButton(true);

    unLink({
      id: [...selectedRows],
      company_id,
      context,
      model: "res.users",
    }).then((response) => {
      response = JSON.parse(response);
      if (response.result) {
        refetchData();
        setSelectedRows([]);
        setOpenConfirmationModal(false);
      }
      handleResponse({
        response,
        setMetaData,
        setTitle,
        successMessage: "User Deleted Successfully",
      });
      setDisableModalButton(false);
    });
  };
  const handleEditUser = (record) => {
    setSelectedUser(record);

    setIsCreateModalOpen(true);
  };
  const toggleSelectAll = () => {
    if (selectedRows.length === UsersList.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(UsersList.map((record) => record.id));
    }
  };
  const handleChangeUsersTypeFilter = (value, e) => {
    setUsersTypeFilter(value);
  };
  const handleChangeUsersSortDirection = () => {
    setFilterDirection(filterDirection === "asc" ? "desc" : "asc");
  };
  const handlechangeUsersSorting = (e) => {
    setUsersSort(e.target.value);
  };
  const handleDeleteUser = () => {
    setOpenConfirmationModal(true);
    setTitle("");
    setMetaData({
      dangerouslySetInnerHTML: "",
      primaryButton: "Yes",
      secondaryButton: "No",
    });
  };

  const toggleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const updatedUsersTableListView = useMemo(() => {
    const updatedList = isVTEX
      ? [...VTEX_USERS_LIST_TABLE_VIEW]
      : [...USERS_LIST_TABLE_VIEW];
    updatedList.splice(0, 1, {
      ...updatedList[0],
      handleCell: (data, item) => {
        return (
          <input
            type="checkbox"
            style={{ accentColor: isVTEX ? "#baf76a" : "#ff5837" }}
            checked={
              data
                ? selectedRows.includes(data[item.name])
                : selectedRows.length === UsersList?.length
            }
            onChange={() =>
              data ? toggleSelectRow(data[item.name]) : toggleSelectAll()
            }
          />
        );
      },
    });
    updatedList.splice(1, 1, {
      ...updatedList[1],
      handleCell: (data, item) => (
        <span role="button" onClick={() => handleEditUser(data.id)}>
          {data[item.name]}
        </span>
      ),
    });
    return updatedList;
  }, [selectedRows, UsersList]);

  const refetchData = () => {
    dispatch(
      userAction.fetchUsersData({
        context,
        company_id,
        pagination: {
          offset: (currentPage - 1) * itemsPerPage,
          limit: itemsPerPage,
        },
        search: {
          query: searchQuery,
          type: UsersTypeFilter?.value || "",
        },

        sort: {
          type: UsersSort || "",
          dir: filterDirection,
        },
      })
    );
  };

  useEffect(() => {
    refetchData();
  }, [currentPage, searchQuery, UsersTypeFilter, UsersSort, filterDirection]);
  useEffect(() => {
    if (shouldUserModalOpen) {
      handleCreateClick();
    } else {
      handleCloseModal();
    }
  }, [shouldUserModalOpen]);

  return (
    <>
      <ConfirmationModal
        handleYes={handleDeleteSelection}
        handleNo={() => setOpenConfirmationModal(false)}
      />
      <MainSectionOfPage className="d-flex orders-first-section">
        <div className=" d-flex d-none d-md-flex product_filter_div">
          <ReactSelect
            value={UsersTypeFilter}
            options={UsersFilterListOptions}
            name="type"
            onChange={handleChangeUsersTypeFilter}
          />
        </div>
        <div className="btn_and_icons">
          {!is_vtex_admin && (
            <NewButton onClick={handleCreateClick} data-isvtex={isVTEX}>
              + {t["New User"]}
            </NewButton>
          )}
          {isCreateModalOpen && (
            <Modal isOpen={isCreateModalOpen} onClose={handleCloseModal}>
              <NewUserForm
                selectedUser={selectedUser}
                // refetchData={refetchData}
                handleCloseModal={() => {
                  handleCloseModal();
                  // refetchData();
                }}
              />
            </Modal>
          )}
          <div className="Filter_icon_div">
            <img
              src={filterSign}
              alt="filter"
              style={{
                transform: `rotate(${
                  filterDirection === "asc" ? "180" : "0"
                }deg)`,
              }}
              onClick={handleChangeUsersSortDirection}
            />
          </div>

          <div className=" d-none d-md-flex  dropdown_list_div d-flex">
            <p className="sort_by">Sort by:</p>
            <select
              className="custom-select"
              onChange={handlechangeUsersSorting}
              value={UsersSort}
              name="type"
            >
              {UsersSortListOption.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </MainSectionOfPage>
      <ProductsContainer>
        <TableContainer data-isvtex={isVTEX}>
          <TableToolbar
            handleDelete={handleDeleteUser}
            handleEditList={handleEditUser}
            setSearchQuery={setSearchQuery}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />

          <table className="table">
            <TableHeader tableHeaderList={updatedUsersTableListView} />
            <TableBody
              tableData={UsersList}
              tableBodyList={updatedUsersTableListView}
              isLoadingData={loading === "pending" || loading === "idle"}
              checkIsLoadingData
            />
          </table>

          <Pagination
            ListViewData={UsersList}
            indexOfFirstItem={indexOfFirstItem}
            indexOfLastItem={indexOfLastItem}
            currentPage={currentPage}
            handleChangePage={handleChangePage}
            PAGINATION_DEFAULT_LIMIT={itemsPerPage}
            totalDataLength={length}
          />
        </TableContainer>
      </ProductsContainer>
    </>
  );
};

export default Users;
